import { Input as HeadlessInput, type InputProps as HeadlessInputProps } from '@headlessui/react';
import { cn } from '../../lib/utils';

export interface InputProps extends HeadlessInputProps {
  className?: string;
}

export function Input({ className, ...props }: InputProps) {
  return (
    <HeadlessInput
      {...props}
      className={cn(
        'block w-full rounded-xl border-none bg-white/[0.02] px-4 py-3 text-sm/6 text-white backdrop-blur-sm',
        'focus:outline-none focus:ring-0',
        'placeholder-white/10 transition-all duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)]',
        'data-[focus]:bg-white/[0.08] data-[focus]:shadow-lg data-[focus]:shadow-blue-500/10 data-[focus]:backdrop-blur-lg',
        'data-[focus]:ring-1 data-[focus]:ring-inset data-[focus]:ring-white/20',
        className
      )}
    />
  );
}